import { render, staticRenderFns } from "./RefundInfoDialog.vue?vue&type=template&id=055b5a3a"
import script from "./RefundInfoDialog.vue?vue&type=script&lang=js"
export * from "./RefundInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports